export default __webpack_public_path__ + "static/media/refresh_Icon.870967ca.svg";